// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"76d5ebc4","832":"2aacd2b1","900":"3253e9b9"}[chunkId] + ".chunk.js";
};